<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-scale`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.9 25.486L25.484 26.9a1 1 0 000 1.414L35.172 38l-5.92.001c-.445 0-.607.046-.77.134a.909.909 0 00-.378.378c-.087.163-.133.324-.133.77v1.436c0 .446.046.607.133.77a.906.906 0 00.378.378c.163.088.325.134.77.134h10.719a2 2 0 002-2V29.282c0-.446-.047-.608-.134-.77a.909.909 0 00-.378-.378c-.163-.088-.325-.134-.77-.134h-1.437c-.445 0-.607.046-.77.134a.909.909 0 00-.378.378c-.087.162-.133.324-.133.77v5.86l-9.657-9.656a1 1 0 00-1.415 0zM8 6a2 2 0 00-2 2v11a1 1 0 001 1h2a1 1 0 001-1v-6.001l9.556 9.557a1 1 0 001.415 0l1.414-1.414a1 1 0 000-1.414L12.657 10H19a1 1 0 001-1V7a1 1 0 00-1-1H8z"/></svg>
</template>
<script>

export default {
  name: 'IconScale',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
